import {ActiveAndPastJobDetailsTypes} from '../ActionTypes/ActiveAndPastJobDetailsTypes';

let initialSate = {
  ActiveAndPastJobDetailsList: [],
};

const ActiveAndPastJobDetailsReducer = (state = initialSate, action) => {
  switch (action.type) {
    case ActiveAndPastJobDetailsTypes.GET_ACTIVE_PAST_JOB_DETAILS:
      state = {...state, ActiveAndPastJobDetailsList: action.payload.data};
      break;
  }
  return state;
};

export default ActiveAndPastJobDetailsReducer;
